import { Divider, Grid } from "@material-ui/core";
import React from 'react';



const ClientiHeadTable = (props) => {





    return (

        <Grid container>
            {props.clienti.map((c, idx) => {
                return (
                    <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>
                            <Grid style={{ textAlign: 'left', paddingTop: 15 }} item xs={5} sm={5} md={5} lg={5} xl={5}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.exercitiuFinanciar}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.an}</span>

                            </Grid>

                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={1} sm={1} md={1} lg={1} xl={1}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.numarClienti}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.nr_clienti}</span>

                            </Grid>
                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.nrFacturiSold}</span>
                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.nr_facturi_sold}</span>

                            </Grid>



                         

                                <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>


                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{props.dictionary.financiar.totalSoldClienti}</span>
                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{c.total_sold}</span>

                                </Grid>

                            


                          

                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={1} sm={1} md={1} lg={1} xl={1}>



                                <i onClick={() => { props.editClienti(c) }} style={{ cursor: 'pointer' }} className='material-icons'>edit</i>




                            </Grid>
                        </Grid>
                        <Divider className='pm-divider' style={{ marginTop: 20 }} />
                    </Grid>
                )
            })}



        </Grid>

    )
}



export default ClientiHeadTable;